import ImageCollection from './ImageCollection';

export default ImageCollection;
